import { render, staticRenderFns } from "./clientLayout.vue?vue&type=template&id=79ecc941&scoped=true&"
import script from "./clientLayout.vue?vue&type=script&lang=js&"
export * from "./clientLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ecc941",
  null
  
)

export default component.exports